export const buildNumber = '20260817.1';
export const version = 'main';
export const latestCommit = 'f8b1433d319b75d2ffd9b9c610cd227f1237a482';
